import { render } from "./BannerFull.vue?vue&type=template&id=93144fd6&scoped=true"
import script from "./BannerFull.vue?vue&type=script&lang=js"
export * from "./BannerFull.vue?vue&type=script&lang=js"

import "./BannerFull.vue?vue&type=style&index=0&id=93144fd6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93144fd6"]])

export default __exports__